import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class VisitMetricData<T = any> {
  private _api = inject(FsApi);


  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'visitmetrics',
      query,
      {
        key: 'visitMetrics',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `visitmetrics/${data.id}`,
      data,
      {
        key: 'visitMetrics',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'visitmetrics',
      data,
      {
        key: 'visitMetrics',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `visitmetrics/${data.id}`,
      data,
      {
        key: 'visitMetrics',
        ...config,
      },
    );
  }

  public metricFundSearch(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'visitmetrics/metric/fund/search',
      data,
      {
        key: '',
        ...config,
      },
    );
  }

  public metricFundView(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'visitmetrics/metric/fund/view',
      data,
      {
        key: '',
        ...config,
      },
    );
  }

  public metricFundUrlClick(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'visitmetrics/metric/fund/click/url',
      data,
      {
        key: '',
        ...config,
      },
    );
  }

  public metricDiseaseDownload(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'visitmetrics/metric/disease/download',
      data,
      {
        key: '',
        ...config,
      },
    );
  }

  public export(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      'visitmetrics/export',
      data,
      {
        key: 'url',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
